import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import ForgedPoem from './ForgedPoem';

// Opt-in wrapper. ForgedPoem is only mounted after the reader opens it, so
// any animation inside it cannot start unasked.
const ForgedPoemSection = () => {
  const [open, setOpen] = useState(false);

  return (
    <section
      id="forged-poem"
      className="py-16 bg-black border-t border-slate-900"
      aria-labelledby="forged-poem-toggle"
    >
      <div className="container mx-auto px-6">
        <div className="max-w-2xl mx-auto text-center">
          <button
            type="button"
            id="forged-poem-toggle"
            onClick={() => setOpen((v) => !v)}
            aria-expanded={open}
            aria-controls="forged-poem-panel"
            data-testid="forged-poem-toggle"
            className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400 focus-visible:ring-offset-2 focus-visible:ring-offset-black rounded-full border border-cyan-500/40 hover:border-cyan-400 px-6 py-3 text-sm font-semibold transition-colors duration-300"
          >
            <span>{open ? 'Hide the poem' : 'Read the poem: Forged'}</span>
            <ChevronDown
              className={`w-4 h-4 motion-safe:transition-transform motion-safe:duration-300 ${open ? 'rotate-180' : ''}`}
              aria-hidden="true"
            />
          </button>

          {!open && (
            <p className="mt-3 text-slate-600 text-xs">
              Optional. Nothing here is needed to choose a machine.
            </p>
          )}
        </div>
      </div>

      <div id="forged-poem-panel" role="region" aria-labelledby="forged-poem-toggle" hidden={!open}>
        {open && <ForgedPoem />}
      </div>
    </section>
  );
};

export default ForgedPoemSection;
